import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { isAuthenticatedAtom, userAtom } from "@/stores/authStore";
import { useNavigate } from "react-router-dom";
import { getDefaultPageForUser } from "@/lib/roleBasedDefaultPage";

export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const user = useAtomValue(userAtom);

  useEffect(() => {
    if (isAuthenticated && user && user.role) {
      navigate(getDefaultPageForUser(user.role, user.isBoUser));
    } else {
      navigate("/login");
    }
  }, [isAuthenticated, navigate, user]);
};
